<div [formGroup]="group" class="field-wrap">
  <cwc-picker
    [label]="config.label | translate"
    [formControlName]="config.name"
    [formControl]="fieldControl"
    [rtl]="rtl"
    [attr.data-test]="config?.dataTId"
    [attr.data-tid]="config?.dataTId"
    [attr.data-name]="config?.name"
    [placeholder]="config.placeholder | translate"
    [status]="controlStatus$ | async"
    [statusMessage]="controlStatusMessage$ | async | translate: statusMessageParameter"
    [required]="isRequired"
    [disabled]="isDisabled|| isLoading"
    [unwrap]="config.unwrap"
    designVersion="v2"
    [emptyMessage]="'views.product.nooptionsavailable' | translate"
    [customSelectedLabel]="customSelectedLabelPicker"
    [filter]="config.filter"
    [filterSecondaryText]="config.filter"
    [filterPlaceholder]="config.filterPlaceholder | translate"
    (cwcOptionCtaClick)="ctaTrigger($event)"
    (cwcFilter)="filterChange($event)"
  >
    <cwc-picker-option *ngFor="let option of options"
                       [attr.disabled]="option.disabled"
                       [value]="option.id"
                       designVersion="v2"
                       [icon]="option.canDelete ? 'delete' : ''"
                       secondaryText="{{option.secondaryText || null}}">
      {{ option.name }}
    </cwc-picker-option>
  </cwc-picker>
  <ng-container *ngIf="temperatureMessage$ | async as temperatureMessage">
    <div class="temperatureMessage" *ngIf="temperatureMessage.length > 0">
       {{ temperatureMessage | translate }}
    </div>
 </ng-container>
  <div class="field-wrap__btn-wrap" *ngIf="config.showExtraButton && showExtraButtonValue">
    <cwc-button
      design-version="v2"
      variant="link"
      [attr.data-test]="orderFieldTestIds?.ADD_NEW_PERSON_LINK"
      leading-icon="plus"
      class="action-link"
      (click)="open()"
    >
      {{ config.labelExtraButton | translate }}
    </cwc-button>
  </div>
</div>
